import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';
import {
  fieldIdCol,
  fieldCbreFeeCol,
  fieldRepresentedPartyCol,
  fieldCounterPartyCol,
  fieldOpportunityNumberCol,
  fieldDateCol,
  fieldNotesCol,
  fieldTransactionTypeCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldFunctionalUnitCol,
  fieldManagingOfficeCol,
  fieldRepRoleCol,
  fieldParentCompanyNameCol,
  fieldBuildingNameCol,
  fieldLocalityCol,
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldSizeCol,
  fieldSizeUomCol,
  fieldRoomsCol,
  fieldUnitsCol,
  fieldAreaCol,
  fieldCompanyOfficeCol,
  fieldConjuntionalAgentCol,
  fieldOtherPartyCol,
  fieldPropertyTypeCol,
  fieldAffiliateCodeCol,
  fieldTeamCol,
  fieldInvoiceTypeCol,
  fieldCurrencyCol,
  fieldMiqIdCol,
  fieldGridIdCol,
  fieldProducedEmployeeIdCol,
  fieldProducedNameCol,
  fieldProducedEmployeeFunctionalUnitIdCol,
  fieldProducedEmployeeFunctionalUnitDescCol,
  fieldProducedEmployeeManagingOfficeIdCol,
  fieldProducedEmployeeManagingOfficeDescCol,
  fieldProducerRoleCol,
  fieldBillToCustomerIdCol,
  fieldDedicatedClientNameBillToCustCol,
  fieldBillToCustomerNameCol,
  fieldReppedCustomerIDCol,
  fieldDedicatedClientNameCol,
  fieldOperatorCol,
  fieldBalanceCol,
  fieldMasterBillingInvoiceCol,
  fieldCreatedByCol,
  fieldSubmittedByCol,
  fieldApprovedByCol,
  fieldPostcodeCol,
  fieldSuburbCol,
  fieldDistrictCol,
  fieldCountryCol,
  fieldRegionCol,
  fieldLandingInvoiceIdCol,
  fieldCbreFeeFumoBalCol,
  fieldCbreRevenueTotalCol,
  fieldCbreRevenueFumoBalCol,
  fieldReppedCustomer,
  fieldValuationFeeCol,
  fieldWeightingPercentageCol,
  fieldMarketValueCol,
  fieldBuildingNlaCol,
  fieldTextCol
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root'
})
export class ValuationSummaryReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_NO'),
        key: 'invoice_no',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 10,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_GRID_ID'),
        key: 'grid_id',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FUNCTIONAL_UNIT'),
        key: 'functional_unit',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MANAGING_OFFICE'),
        key: 'managing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
        key: 'producer_employee_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
        key: 'producer_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
        key: 'producer_functional_unit',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
        key: 'producer_functional_unit_description',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
        key: 'producer_managing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
        key: 'producer_managing_office_description',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRODUCER_ROLE'),
        key: 'producer_role',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COMPANY_OFFICE'),
        key: 'company_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUSTOMER_ID'),
        key: 'bill_to_customer_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME_BILL_TO_CUST'),
        key: 'dedicated_client_name_bill_to_cust',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME_REPPED_CUST'),
        key: 'dedicated_client_name_repped_cust',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPPED_CUSTOMER_ID'),
        key: 'repped_customer_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPERATOR'),
        key: 'operator',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CONJUNCTIONAL_AGENT'),
        key: 'conjunctional_agent',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'repped_customer',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REP_ROLE'),
        key: 'rep_role',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PARENT_COMPANY_NAME'),
        key: 'parent_company_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AFFILIATE_CODE'),
        key: 'affiliate_code',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
        key: 'counter_party',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OTHER_PARTY'),
        key: 'other_party',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('NO_OF_PROPERTIES'),
        key: 'no_of_properties',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left }
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left }
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE'),
        key: 'size',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('UOM'),
        key: 'uom',
        width: 10,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ROOMS'),
        key: 'rooms',
        width: 10,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('UNITS'),
        key: 'units',
        width: 10,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AREA'),
        key: 'area',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_$'),
        key: 'cbre_fee_total',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_FUMO'),
        key: 'cbre_fee_fumo_balance',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_REVENUE_$'),
        key: 'cbre_revenue_total',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
        key: 'cbre_revenue_fumo_balance',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('NOTES'),
        key: 'notes',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BALANCE'),
        key: 'balance',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MASTER_BILLING_INVOICE'),
        key: 'master_billing_invoice',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPPED_CUSTOMER'),
        key: 'repped_customer',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('VALUATION_FEE'),
        key: 'valuation_fee',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('WEIGHTING_PERCENTAGE'),
        key: 'weighting_percentage',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NLA'),
        key: 'building_nla',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NLA_UOM'),
        key: 'building_nla_uom',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MARKET_VALUE'),
        key: 'market_value',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle }
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
        field: 'finishline_id',
      },
      {
        ...fieldLandingInvoiceIdCol,
        field: 'invoice_no',
        headerName: this.translateService.getTranslation('INVOICE_NO'),
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
        width: 100,
      },
      {
        ...fieldDateCol,
        headerName: this.translateService.getTranslation('INVOICE_DT'),
        field: 'invoice_date'
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
        width: 100,
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },
      {
        ...fieldOpportunityNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY'),
        width: 120,
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldGridIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_GRID_ID'),
      },
      {
        ...fieldFunctionalUnitCol,
        headerName: this.translateService.getTranslation('FUNCTIONAL_UNIT'),
      },
      {
        ...fieldManagingOfficeCol,
        headerName: this.translateService.getTranslation('MANAGING_OFFICE'),
      },
      {
        ...fieldProducedEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
      },
      {
        ...fieldProducedNameCol,
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
      },
      {
        ...fieldProducedEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
      },
      {
        ...fieldProducedEmployeeFunctionalUnitDescCol,
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
      },
      {
        ...fieldProducedEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
      },
      {
        ...fieldProducedEmployeeManagingOfficeDescCol,
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
      },
      {
        ...fieldProducerRoleCol,
        headerName: this.translateService.getTranslation('PRODUCER_ROLE'),
      },
      {
        ...fieldCompanyOfficeCol,
        headerName: this.translateService.getTranslation('COMPANY_OFFICE'),
      },
      {
        ...fieldBillToCustomerIdCol,
        headerName: this.translateService.getTranslation('BILL_TO_CUSTOMER_ID'),
      },
      {
        ...fieldDedicatedClientNameBillToCustCol,
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME_BILL_TO_CUST'),
      },
      {
        ...fieldBillToCustomerNameCol,
        headerName: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
      },
      {
        ...fieldDedicatedClientNameCol,
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME_REPPED_CUST'),
      },
      {
        ...fieldReppedCustomerIDCol,
        headerName: this.translateService.getTranslation('REPPED_CUSTOMER_ID'),
      },
      {
        ...fieldOperatorCol,
        headerName: this.translateService.getTranslation('OPERATOR'),
      },
      {
        ...fieldConjuntionalAgentCol,
        field: 'conjunctional_agent',
        headerName: this.translateService.getTranslation('CONJUNCTIONAL_AGENT'),
        valueGetter: (params: any) => {
          return params?.data?.affiliate_code ? params.data.conjunctional_agent : '';
        },
      },
      {
        ...fieldRepresentedPartyCol,
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
        field: 'repped_customer'
      },
      {
        ...fieldRepRoleCol,
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },
      {
        ...fieldParentCompanyNameCol,
        headerName: this.translateService.getTranslation('PARENT_COMPANY_NAME'),
      },
      {
        ...fieldAffiliateCodeCol,
        headerName: this.translateService.getTranslation('AFFILIATE_CODE'),
      },
      {
        ...fieldCounterPartyCol,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
      },
      {
        ...fieldOtherPartyCol,
        headerName: this.translateService.getTranslation('OTHER_PARTY'),
      },
      {
        ...fieldTextCol,
        field: 'no_of_properties',
        headerName: this.translateService.getTranslation('NO_OF_PROPERTIES'),
        minWidth: 170,
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },
      {
        ...fieldSizeCol,
        headerName: this.translateService.getTranslation('SIZE'),
      },
      {
        ...fieldSizeUomCol,
        field: 'uom',
        headerName: this.translateService.getTranslation('UOM'),
      },
      {
        ...fieldRoomsCol,
        headerName: this.translateService.getTranslation('ROOMS'),
      },
      {
        ...fieldUnitsCol,
        headerName: this.translateService.getTranslation('UNITS'),
      },
      {
        ...fieldAreaCol,
        headerName: this.translateService.getTranslation('AREA'),
      },
      {
        ...fieldCbreFeeCol,
        field: 'cbre_fee_total',
        headerName: this.translateService.getTranslation('CBRE_FEE_$'),
      },
      {
        ...fieldCbreFeeFumoBalCol,
        field: 'cbre_fee_fumo_balance',
        headerName: this.translateService.getTranslation('CBRE_FEE_FUMO'),
      },
      {
        ...fieldCbreRevenueTotalCol,
        field: 'cbre_revenue_total',
        headerName: this.translateService.getTranslation('CBRE_REVENUE_$'),
      },
      {
        ...fieldCbreRevenueFumoBalCol,
        field: 'cbre_revenue_fumo_balance',
        headerName: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
      },
      {
        ...fieldNotesCol,
        field: 'notes',
        cellRenderer: 'reportingNotes',
        headerName: this.translateService.getTranslation('NOTES'),
        width: 100,
        cellClass: 'ag-flex-align-center',
      },
      {
        ...fieldBalanceCol,
        headerName: this.translateService.getTranslation('BALANCE'),
      },
      {
        ...fieldMasterBillingInvoiceCol,
        headerName: this.translateService.getTranslation('MASTER_BILLING_INVOICE'),
      },
      {
        ...fieldReppedCustomer,
        headerName: this.translateService.getTranslation('REPPED_CUSTOMER'),
      },
      {
        ...fieldValuationFeeCol,
        headerName: this.translateService.getTranslation('VALUATION_FEE'),
        width: 160
      },
      {
        ...fieldWeightingPercentageCol,
        headerName: this.translateService.getTranslation('WEIGHTING_PERCENTAGE'),
        width: 160
      },
      {
        ...fieldBuildingNlaCol,
        headerName: this.translateService.getTranslation('BUILDING_NLA'),
        width: 160
      },
      {
        ...fieldBuildingNlaCol,
        field: 'building_nla_uom',
        headerName: this.translateService.getTranslation('BUILDING_NLA_UOM'),
        width: 160
      },
      {
        ...fieldMarketValueCol,
        headerName: this.translateService.getTranslation('MARKET_VALUE'),
        width: 160
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },
    ];
  }
}
